import { render, staticRenderFns } from "./BoxItem.vue?vue&type=template&id=f0561b64&"
import script from "./BoxItem.vue?vue&type=script&lang=js&"
export * from "./BoxItem.vue?vue&type=script&lang=js&"
import style0 from "./BoxItem.vue?vue&type=style&index=0&id=f0561b64&prod&lang=css&"
import style1 from "./BoxItem.vue?vue&type=style&index=1&id=f0561b64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports